var data = {
	"body": "<rect width=\"12.824\" height=\"12.824\" x=\"-736.344\" y=\"737.679\" transform=\"scale(96.7529) rotate(-45 -1245.095 -516.544)\" ry=\".199\" fill=\"transparent\" stroke=\"currentColor\" stroke-width=\"1.15\"/>",
	"width": 2048,
	"height": 2048
};
exports.__esModule = true;
exports.default = data;
